import { Controller } from "@hotwired/stimulus"
import { ReservationDetailHandler } from "../utils/reservation-detail-handler"

// Bootstrap Modalを動的にインポート
let Modal

export default class extends Controller {
  static values = { weekStart: String }

  async connect() {
    // Bootstrap Modalを動的にインポート
    const bootstrap = await import("bootstrap")
    Modal = bootstrap.Modal

    this.detailHandler = new ReservationDetailHandler(this.element)
    this.setupCalendarInteractions()
  }

  setupCalendarInteractions() {
    this.element.addEventListener('click', this.handleCalendarClick.bind(this))
  }

  handleCalendarClick(event) {
    const reservationCell = event.target.closest('.reservation-cell')
    const emptyCell = event.target.closest('.empty-cell')

    if (reservationCell) {
      this.detailHandler.showReservationDetail(reservationCell)
    } else if (emptyCell) {
      this.openReservationModal(emptyCell)
    }
  }

  openReservationModal(cell) {
    const date = cell.dataset.date
    const time = cell.dataset.time
    const modal = document.querySelector('#reservationModal')
    const startTimeInput = modal.querySelector('[data-reservation-form-target="startTime"]')

    startTimeInput.value = `${date}T${time}`

    const bootstrapModal = Modal.getOrCreateInstance(modal)
    bootstrapModal.show()
  }
}
